exports.captureTypes = ['Image', 'Video'];
